// @flow
import React, { useCallback } from "react"
import StarEmpty from "@kiwicom/orbit-components/lib/icons/StarEmpty"
import StarFull from "@kiwicom/orbit-components/lib/icons/StarFull"
import ButtonLink from "@kiwicom/orbit-components/lib/ButtonLink"

import type Journey from "common/records/Journey"
import type PassengersCount from "common/records/PassengersCount"
import type { CabinClass } from "common/records/CabinClass"

type Props = {
  active: ?boolean,
  journey: Journey,
  passengers: PassengersCount,
  cabinClass: ?CabinClass,
  onToggle: (Journey, PassengersCount, ?CabinClass) => void,
}

const JourneyStar = ({ active, journey, passengers, cabinClass, onToggle }: Props) => {
  const Icon = active ? StarFull : StarEmpty
  const handleClick = useCallback(
    (e: SyntheticEvent<*>) => {
      e.stopPropagation()
      e.preventDefault()
      onToggle(journey, passengers, cabinClass)
    },
    [onToggle, journey, passengers, cabinClass],
  )
  const color = active ? "warning" : "secondary"
  return (
    <ButtonLink
      onClick={handleClick}
      role="checkbox"
      iconLeft={<Icon color={color} />}
      type="secondary"
    />
  )
}

export default JourneyStar
